var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:" align menu-unfold"},[_c('div',{staticClass:"box"}),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.props.title))]),(_vm.props.new)?_c('img',{attrs:{"src":"https://s6.bihukankan.com/img/0611new.svg","alt":"new"}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }